// SafeImg: a plain <img> that never renders a broken-image icon.
// On load error (or an empty src) it swaps to a neutral placeholder block
// with the same geometry instead. Stitches-aware: accepts the `css` prop
// like other primitives. Use for remote artwork where next/image is
// impractical; for next/image-based rendering with the same guarantee,
// use components/primitives/Img.
import { faImage } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ComponentProps, useEffect, useState } from 'react'
import { styled } from 'stitches.config'
import Box from 'components/primitives/Box'

const StyledImg = styled('img', {})

type Props = ComponentProps<typeof StyledImg> & {
  iconSize?: '1x' | '2x' | '4x'
}

const SafeImg = ({ iconSize = '2x', css, ...rest }: Props) => {
  const [broken, setBroken] = useState(false)

  useEffect(() => {
    setBroken(false)
  }, [rest.src])

  if (broken || !rest.src) {
    return (
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '$gray3',
          color: '$gray8',
          ...css,
        }}
      >
        <FontAwesomeIcon icon={faImage} size={iconSize} />
      </Box>
    )
  }

  return <StyledImg {...rest} css={css} onError={() => setBroken(true)} />
}

export default SafeImg
